"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M15.31 18.9c-.96 1-2.06 2.03-3.31 3.1-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2c4 0 7.64 2.92 7.97 7.5h3.53L19 14l-4.5-4.5h3.47C17.65 6.24 15.13 4 12 4c-3.35 0-6 2.57-6 6.2 0 2.34 1.95 5.44 6 9.14q.96-.885 1.77-1.71c-.17-.34-.27-.72-.27-1.12 0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5S17.38 19 16 19c-.24 0-.47-.03-.69-.1"
}), 'ModeOfTravelSharp');